import { questBgThemeColor } from "../utils";

export interface Props {
  label: string;
  active: boolean;
  onClick: React.MouseEventHandler;
  id: string;
  filterOption?: string;
}

const FilterTag = ({ active, onClick, id, label, filterOption }: Props) => {
  const getTagColor = () => {
    if (!active) return "bg-none text-gray-500";
    if (filterOption === "status" || filterOption === "completion")
      return "bg-black text-white";
    return `${questBgThemeColor(id)} text-black`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="tag"
      className={`uppercase captionText flex grow-0 items-center gap-2 rounded-full border border-light-gray py-2 px-4 ${getTagColor()}`}
      id={id}
    >
      {label}
    </button>
  );
};

export default FilterTag;
